import { IColoredUser } from "@services/getUsers";
import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useUsers = () => {
  const { users } = useSelector((state: RootState) => state.users);
  return users || [];
};
